import { render, staticRenderFns } from "./PatientAccept.vue?vue&type=template&id=674fe75b&scoped=true&"
import script from "./PatientAccept.vue?vue&type=script&lang=ts&"
export * from "./PatientAccept.vue?vue&type=script&lang=ts&"
import style0 from "./PatientAccept.vue?vue&type=style&index=0&id=674fe75b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fe75b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VExpandTransition,VForm,VRow})
